import axios from 'axios';
import { Purchase } from '../ts-components/page-projects/MassMessagingModal/MassMessagingModal';

type Recipient = {
  projectId: string,
  areaId: string,
  supplierId: string,
  supplierMemberId: string,
}

export const getSupplierToMassMessageTo = async (projectId: string): Promise<Purchase[]> => {
  const response = await axios.get(`/api/massMessage/${projectId}/`);
  return response.data;
}

export const sendMassMessage = async (orgSlug: string, recipients: Recipient[], message: string, files: File[] = []) => {
  const formData = new FormData();
  
  // Add data as a single field that matches backend expectations
  const data = {
    recipients: recipients,
    message: message
  };
  formData.append('data', JSON.stringify(data));
  
  // Add files if any
  if (files.length > 0) {
    files.forEach(file => {
      formData.append('fileData', file);
    });
  }

  const response = await axios.post(`/api/organizations/${orgSlug}/massMessage/send`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  });
  return response.data;
}
